import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-subject-attendance',
  templateUrl: './subject-attendance.component.html',
  styleUrls: ['./subject-attendance.component.scss']
})
export class SubjectAttendanceComponent implements OnInit {

  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService) { }

  id:any = 0;
  slot:any = {batch:{course:{}}, topic:{}};
  students:any = {list:[], count:0};
  limit:any = 30;
  offset:any = 0;
  search:any = "";
  loading:any = false;
  date:any = "";
  today:any = "";
  attendance:any = [];
  isHoliday:any = false;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('slotId');
    this.date = new Date();
    this.today = new Date();

    this.loadSlot();
    this.loadBatch();
    
    this.loadAttendance();
  }

  loadSlot(){
    this.dataService.getTTSlot(this.id).subscribe( (data: any )=> {
      if(data.status == 0){
        this.slot = data;
        this.loadStudents(this.slot.batch.id);
      }
      
    } );
  }

  loadBatch(){
    /*this.dataService.getBatch(this.id).subscribe( (data: any )=> {
      if(data.status == 0){
        this.batch = data;
      }
      
    } ); */
  }

  loadStudents(batchId){
    this.dataService.getStudents(this.limit, this.offset, this.search, batchId).subscribe( (data: any )=> {
      if(data.status == 0){
        this.students = data;
      }
    } );
  }

  paginate(dir){
    if(dir == 2) {
      this.offset += this.limit;
    } else {
      this.offset -= this.limit;
      if(this.offset < 0){
        this.offset = 0;
      }
    }

    this.loadStudents(this.slot.batch.id);

  }

  formattedDate(date){
    const year = date.getFullYear();
    // Month is zero-indexed, so we add 1 to get the actual month
    const month = date.getMonth() + 1;
    const day = date.getDate();

    // Format the date as a string (optional)
    //const formattedDate = `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`; //d-m-Y
    const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`; //Y-m-d

    return formattedDate;
  }

  forwardDate(){
    const nextDate = new Date(this.date);
    nextDate.setDate(nextDate.getDate() + 1);
    this.date = nextDate;
    this.loadAttendance();
  }

  backwardDate(){
    const previousDate = new Date(this.date);
    previousDate.setDate(previousDate.getDate() - 1);
    this.date = previousDate;
    this.loadAttendance();
  }

  setCustomDate(date){
    this.date = new Date(date);
    this.loadAttendance();
  }

  loadAttendance(){
    this.attendance = {};
    this.dataService.getSubjectAttendance(this.id, this.formattedDate(this.date)).subscribe( (data: any )=> {
      if(data.status == 0){
        this.attendance = data.data;
        this.isHoliday = data.isHoliday;
      }
    } );
  }

  markAttendance(studentId, attendance){
    if (!this.attendance[studentId]) {
      this.attendance[studentId] = {}; // Create an empty object if it doesn't exist
    }

    let data = {
      student_id:studentId,
      attendance:attendance,
      date: this.formattedDate(this.date),
      slot_id: this.id,
      topic_id:this.slot.topic.id
    }
    this.attendance[studentId] = attendance;
    this.loading = true;
    this.dataService.postSubjectAttendance(data).subscribe( (res:any) => {
      this.loading = false;
      if(res.status == 0) {
        //
      } else {
        alert(res.msg);
      }

    });
  }

}
